import { match } from '@frontend/duck-tape';
import { useMemo } from '@frontend/react';
import { EmptyScheduledTaskCard, EmptyTaskCard } from '@frontend/web-icons';
import { Text, YStack } from '@frontend/web-react';

type EmptyTaskProps = {
  type: 'no_filtered_task' | 'no_recurrence' | 'no_task';
};

export const EmptyTask = ({ type }: EmptyTaskProps) => {
  const content = useMemo(() => {
    return match(type)
      .with('no_task', () => ({
        card: <EmptyTaskCard />,
        description: 'Reset the filter to find tasks.',
        title: 'Filter game too strong.',
      }))
      .with('no_recurrence', () => ({
        card: <EmptyScheduledTaskCard />,
        description: "Put your ongoing to-do's on repeat.",
        title: 'No scheduled tasks yet.',
      }))
      .otherwise(() => ({
        card: <EmptyTaskCard />,
        description: "A busy person like you? That's impossible.",
        title: 'You have no tasks yet.',
      }));
  }, [type]);

  return (
    <YStack className="gap-md flex-1 grow-1 justify-center items-center mt-xxl">
      {content.card}
      <YStack className="gap-sm ">
        <Text color="tertiary" textAlign="center" type="h5">
          {content.title}
        </Text>
        <Text color="tertiary" textAlign="center" type="p-sm">
          {content.description}
        </Text>
      </YStack>
    </YStack>
  );
};
